import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Phone } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { reachGoal } from "../lib/metrika";

const navItems = [
  { to: "/", label: "Каталог" },
  { to: "/dostavka-pirogov-ulyanovsk/", label: "Доставка" },
  { to: "/o-kompanii/", label: "О нас" },
  { to: "/blog", label: "Блог" },
  { to: "/kontakty/", label: "Контакты" },
];

const Header = () => {
  const { count, setOpen, bumpKey } = useCart();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full bg-[#F9F6F0]/85 backdrop-blur-xl border-b border-[#E8E3DA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            data-testid="logo-link"
            className="flex items-center gap-3 group"
          >
            <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center overflow-hidden">
              <img
                src="/apple-touch-icon.png"
                alt="Ишеевские пироги"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <div className="font-display text-2xl leading-none text-[#2C2520]">
                Ишеевские
              </div>
              <div className="label-eyebrow leading-none mt-1">
                пироги
              </div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => window.scrollTo(0, 0)}
                data-testid={`nav-${item.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-full transition-colors ${
                    isActive
                      ? "text-[#2C2520] bg-[#F2EBE1]"
                      : "text-[#5C4F45] hover:text-[#2C2520]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <NavLink
              to="/"
              end
              onClick={() => setTimeout(() => document.getElementById("catalog")?.scrollIntoView({ behavior: "smooth" }), 50)}
              className={({ isActive }) =>
                `sm:hidden px-3 py-2 text-sm font-medium rounded-full transition-colors ${
                  isActive ? "text-[#2C2520] bg-[#F2EBE1]" : "text-[#5C4F45]"
                }`
              }
            >
              Каталог
            </NavLink>
            <a
              href="tel:+79378764537"
              data-testid="header-phone"
              className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-[#2C2520] hover:text-[#C65D3B] transition-colors"
            >
              <Phone size={16} />
              +7 937 876 45 37
            </a>
            <button
              id="cart-icon-target"
              data-testid="open-cart-button"
              onClick={() => {
                reachGoal("cart_open");
                setOpen(true);
              }}
              className="relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#2C2520] text-[#F9F6F0] hover:bg-[#1c1714] transition-colors"
            >
              <ShoppingBag
                key={bumpKey}
                size={18}
                className={count > 0 ? "cart-bounce" : ""}
              />
              {count > 0 && (
                <span className="sm:hidden absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#C65D3B] text-white text-[10px] font-bold flex items-center justify-center">
                  {count}
                </span>
              )}
              <span className="hidden sm:inline text-sm font-medium" data-testid="cart-count">
                Корзина · {count}
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
